import { useEffect } from 'react'
import { sidebarWidth } from '../features/student/Sidebar'
import { BOX_SHADOW, Frontend_URL } from '../shared/constants'
import { Box, Drawer, IconButton, Stack, Typography } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import useDrawer from '../shared/hook/useDrawer';
import useResponsive from '../shared/hook/useResponsive';
import logo from './../assets/img/logo-new.png'
import { useLocation } from 'react-router-dom';
import usePayoutStore from '../store/usePayoutStore';
import useMarketingDetailStore from '../store/useMarketingDetailStore';
import useContactPersonStore from '../store/useContactPersonStore';
import useZoneStore from '../store/useZoneStore';
import useFacilityStore from '../store/useFacilityStore';
import useClusterZoneStore from '../store/useClusterZoneStore';
import useStudentDetailStore from '../store/useStudentDetailStore';
import SidebarMenuWithChangePassword from './SidebarMenuWithChangePassword';
import useAuthStore from '../store/useAuthStore';
import packageJson from "../../package.json";
import CustomDivider from '../shared/utils/CustomDivider';
import { useGetUserDetail } from '../assets/api/UseStudentGetApi';

const MainSidebar = ({ children, menuLists }) => {
  const { user } = useAuthStore()
  const { data } = useGetUserDetail()
  const userDetail = data?.data
  const { open, toggleDrawer } = useDrawer();
  const isSmallScreen = useResponsive("lg");
  const location = useLocation();
  const { clearPayoutDetail } = usePayoutStore()
  const { clearMarketingDetail } = useMarketingDetailStore();
  const { clearContactperson } = useContactPersonStore()
  const { clearZone } = useZoneStore()
  const { clearFacility } = useFacilityStore()
  const { clearClusterZone } = useClusterZoneStore()
  const { clearStudentDetail } = useStudentDetailStore()
  useEffect(() => {
    clearPayoutDetail();
    clearContactperson();
    clearMarketingDetail();
    clearClusterZone();
    clearFacility();
    clearZone();
    clearStudentDetail();
  }, [location.pathname]);
  return (
    <>
      {!isSmallScreen && (
        <Box display="flex">
          <Box sx={{
            width: sidebarWidth,
            position: "fixed",
            top: 0,
            left: 0,
            bottom: "10px",
            height: "100vh",
            boxShadow: BOX_SHADOW,
            paddingBottom: "20px",
            overflowY: "scroll",
            "&::-webkit-scrollbar": {
              width: "0px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "transparent",
            },
          }}>


            <img src={logo} alt="Logo" style={{ width: "150px", cursor: "pointer", display: "block", margin: "20px auto" }} onClick={() => (window.location.href = Frontend_URL)} />
            <Stack px={"1rem"}>
              {user?.role !== "trainer" && <Typography variant='body2'>Name:{userDetail?.firstname} {userDetail?.lastname}</Typography>}
              {user?.role !== "trainer" && <Typography variant='body2'>Role:{user?.role}</Typography>}
              {
                (user?.role !== "Admin" && user?.role !== "organizer" && user?.role !== "trainer") && <Typography variant='body2'>Report To:{`${userDetail?.reporting_user?.firstname} ${userDetail?.reporting_user?.lastname} `}</Typography>
              }

            </Stack>

            <SidebarMenuWithChangePassword
              menuList={menuLists}
            />
            <Typography textAlign={"center"} variant="h6"> Version : {packageJson.version}</Typography>

            {/* <RenderMenuList menuList={menuLists} />
            <IconButton onClick={() => { }}>
              <Typography variant='body2' textAlign={"center"} fontSize={"0.8rem"}>Change Password</Typography>
            </IconButton> */}
            <CustomDivider size={"1rem"} />

          </Box>

          <Box sx={{ flexGrow: 1, width: `calc(100% - ${sidebarWidth})`, }}>
            <Box sx={{ p: "15px", ml: sidebarWidth, backgroundColor: "primary.main" }}>
              {children}
            </Box>
          </Box>
        </Box>
      )}

      {isSmallScreen && (
        <Box>

          <Box sx={{ position: "sticky", top: "0px", py: 1, bgcolor: "#fff", left: "5px", zIndex: 200, display: "flex", justifyContent: "space-between", alignItems: "center" }}>

            <IconButton onClick={() => toggleDrawer(true)}>
              <MenuIcon sx={{ color: "#000", fontSize: "20px" }} />
            </IconButton>
            <img src={logo} alt="Logo" style={{ width: "80px", cursor: "pointer" }} onClick={() => (window.location.href = Frontend_URL)} />

          </Box>


          <Box sx={{ backgroundColor: "primary.main", px: "5px", py: "10px" }}>
            {children}
          </Box>

          <Drawer anchor="left" open={open} onClose={() => toggleDrawer(false)}>
            <Box sx={{ width: "290px" }}>
              <img src={logo} alt="Logo" style={{ width: "150px", cursor: "pointer", display: "block", margin: "20px auto" }} onClick={() => (window.location.href = Frontend_URL)} />
              <Stack px={"1rem"}>
                {user?.role !== "trainer" && <Typography variant='body2'>Name:{userDetail?.firstname} {userDetail?.lastname}</Typography>}
                {user?.role !== "trainer" && <Typography variant='body2'>Role:{user?.role}</Typography>}
                {
                  (user?.role !== "Admin" && user?.role !== "organizer" && user?.role !== "trainer") && <Typography variant='body2'>Report To:{`${userDetail?.reporting_user?.firstname} ${userDetail?.reporting_user?.lastname} `}</Typography>
                }

              </Stack>
              <SidebarMenuWithChangePassword
                menuList={menuLists}
              />
              <Typography textAlign={"center"} variant="h6"> Version : {packageJson.version}</Typography>
              <CustomDivider size={"1rem"} />
            </Box>
          </Drawer>
        </Box>
      )}
    </>
  )
}

export default MainSidebar;
